// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_e4-a";
export var fulfillmentFormRail = "_e4-9";
export var headerTitleRow = "_e4-c";
export var orderDetailsWrapper = "_e4-7";
export var orderLinkTrigger = "_e4-2";
export var paymentInformationGrid = "_e4-h";
export var paymentSummaryColumn = "_e4-i";
export var shipmentContainer = "_e4-b";
export var shipmentDetailsMainPane = "_e4-8";
export var shipmentNavigationCard = "_e4-5";
export var shipmentNavigationRail = "_e4-3";
export var shipmentNavigationRailHeader = "_e4-4";
export var shipmentSummaryFact = "_e4-e";
export var shipmentSummaryGrid = "_e4-d";
export var shipmentSummaryMetadataRow = "_e4-f";
export var shipmentSummaryTags = "_e4-g";
export var shipmentWorkspace = "_e4-0";
export var shipmentWorkspaceContent = "_e4-6";
export var shipmentWorkspaceHeader = "_e4-1";